import _ from 'underscore';
import I18n from 'helpers/I18n';
import React from 'react';

class LoginPage extends React.Component {
  static propTypes = {
    testResultUUID: React.PropTypes.string.isRequired,
    topicID:        React.PropTypes.number,
  }

  handleClick = (e) => {
    e.preventDefault();
    window.location.href = e.target.href;
  }

  authHrefWithState(href) {
    return `${href}?state=${encodeURIComponent(this.props.testResultUUID)}`;
  }

  noAuthHref() {
    return `/tests/${this.props.testResultUUID}`
  }

  render() {
    let text = <p>{I18n.t("login_page.text")}</p>;

    return (
      <div className="">
        <div className="page-header">
          <h1 className="m-b-0">{I18n.t("login_page.title")}</h1>
        </div>
        <div className="p-b-20">{text}</div>
        <div className="container">
          <div className="row m-tb-5">
            <a href={this.authHrefWithState("/auth/vkontakte")}
               className="col-md-2 text-left btn btn-vk"
               onClick={this.handleClick}><span className="fa fa-vk"></span> Vkontakte</a>
          </div>
          <div className="row m-tb-5">
            <a href={this.authHrefWithState("/auth/google_oauth2")}
               className="col-md-2 text-left btn btn-google"
               onClick={this.handleClick}><span className="fa fa-google"></span> Google+</a>
          </div>
          <div className="row m-tb-5 p-t-20">
            <a href={this.noAuthHref()}>{I18n.t("login_page.skip")}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./app/javascript/components/application/LoginPage.jsx